import vueInstance from "../main";

export const fieldTypes = Object.freeze({
  FIELD_TYPE_GROSS_AMOUNT: 1,
  FIELD_TYPE_NET_AMOUNT: 2
});

export const serviceTypeGroups = Object.freeze({
  SERVICE_TYPE_GROUP_ALL: 1,
  SERVICE_TYPE_GROUP_FLIGHT: 2
});

export const dateTypes = Object.freeze({
  DATE_TYPE_CREATED_AT: 0,
  DATE_TYPE_ISSUE_DATE: 1,
  DATE_TYPE_SALE_DATE: 2
});

export const fieldTypesNames = function() {
  return [
    {
      text: vueInstance.$t("booking.grossAmount"),
      value: fieldTypes.FIELD_TYPE_GROSS_AMOUNT
    },
    {
      text: vueInstance.$t("booking.netAmount"),
      value: fieldTypes.FIELD_TYPE_NET_AMOUNT
    }
  ];
};

export const serviceTypesNames = function() {
  return [
    {
      text: vueInstance.$t("booking.serviceTypeAll"),
      value: serviceTypeGroups.SERVICE_TYPE_GROUP_ALL
    },
    {
      text: vueInstance.$t("booking.serviceTypeFlight"),
      value: serviceTypeGroups.SERVICE_TYPE_GROUP_FLIGHT
    }
  ];
};

export const dateTypesNames = function() {
  return [
    {
      text: vueInstance.$t("booking.dateTypeCreatedAt"),
      value: dateTypes.DATE_TYPE_CREATED_AT
    },
    {
      text: vueInstance.$t("booking.dateTypeIssueDate"),
      value: dateTypes.DATE_TYPE_ISSUE_DATE
    },
    {
      text: vueInstance.$t("booking.dateTypeSaleDate"),
      value: dateTypes.DATE_TYPE_SALE_DATE
    }
  ];
};
